module.exports = __webpack_public_path__ + "static/media/truck-main-img.dc725e2a.jpg";